import { render, staticRenderFns } from "./CaseItem.vue?vue&type=template&id=f5749830&scoped=true"
import script from "./CaseItem.vue?vue&type=script&lang=ts"
export * from "./CaseItem.vue?vue&type=script&lang=ts"
import style0 from "./CaseItem.vue?vue&type=style&index=0&id=f5749830&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5749830",
  null
  
)

export default component.exports